import React from 'react';
import '../Oficina/Oficina.css';
import '../../../src/styles/mediaqueries.css';

const Oficina = () => {

return (
    <div className='desc-oficina'>
        <div id='oficina-desc' className='section-description'>
        Também contamos com <strong>eventos mensais</strong>, como nossa <strong>Oficina de Artes</strong>!
        <br />Acompanhe-nos no <strong>Instagram</strong> para ficar por dentro das novidades e conteúdos!
        </div>
    </div>
);
};

export default Oficina;